import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Translation from "common/translations/Translations";
import Currencies from "common/currencies/Currencies";

import AlgorandLogoIcon from "theme/icons/AlgorandLogo";
import ColorList from "common/colors/ColorList";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
	const userSettings = useSelector((state) => state.UserSettings);

	const [themeMode, setThemeMode] = useState("light");
	const [themeColor, setThemeColor] = useState(ColorList[0]);
	const [appLanguage, setAppLanguage] = useState(Translation?.en);
	const [baseCurrency, setBaseCurrency] = useState(null);

	useEffect(() => {
		if (userSettings?.["theme-mode"]) setThemeMode(userSettings["theme-mode"]);
		if (userSettings?.["theme-color"]) setThemeColor(userSettings["theme-color"]);
		if (userSettings?.["app-language"]) setAppLanguage(Translation[userSettings["app-language"]]);

		if (userSettings?.["base-currency"]) setBaseCurrency(Currencies(themeColor?.hex, userSettings["base-currency"]));
		else
			setBaseCurrency({
				icon: <AlgorandLogoIcon fill={themeColor?.hex} />,
				"currency-code": "algo",
				language: "Algo",
			});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [themeMode, themeColor, userSettings]);

	return (
		<ThemeContext.Provider
			value={{
				themeMode,
				setThemeMode,
				themeColor,
				setThemeColor,
				appLanguage,
				setAppLanguage,
				baseCurrency,
				setBaseCurrency,
			}}
		>
			{children}
		</ThemeContext.Provider>
	);
};

export default ThemeProvider;
